import React, { Component } from "react";
import { SLA_FILTERS, STATUS_CODE_MAP, USER } from "../../../constants/provider/constant";
import Container from '@mui/material/Container';
import { AppointmentDetails, checkSlaTime } from "../../../services/provider/common";
import Alert from '@mui/material/Alert';
import AppointmentConfirmedTable from "./appointments-data";
import AlertTitle from '@mui/material/AlertTitle';
import { MaskElement, getAppointmentDate, getAppointmentTime, getCorrectDateFormat } from "../../../services/provider/common";
import { toast } from "react-toast";

class AppointmentConfirmedProvider extends Component {
  constructor(props) {
    let pgDetail = JSON.parse(localStorage.getItem("pageTracking"))
    super(props);
    this.state = {
      requests: [],
      rows: [],
      pageNo: this.getPageNo(this.props.match.params.status, true),
      messageAPI: '',
      startDate: "",
      endDate: "",
      state: this.props.location.state,
      searchAppointment: this.props.searchAppointment,
      searchAPIValues: this.props.searchAPIValues,
      status: this.props.match.params.status ? this.props.match.params.status : undefined,
      statusId: this.assignStatusId(this.props.match.params.status),
      action:"confirm",
      slaBreachType : null,
      totalRows:(localStorage.getItem("req") === window.location.hash) ? pgDetail?.totalRows : null,
      isMobileView: false
    }
    this.setIsMobileView = this.setIsMobileView.bind(this);
    this.callAppointmentDetails = this.callAppointmentDetails.bind(this);
  }
  setIsMobileView(val) {
    this.setState({...this.state, isMobileView: val});
  }

  getPageNo(status, val=false) {
    let reqToken = localStorage.getItem("req");
    if(reqToken){
      if(window.location.hash === reqToken)
      return JSON.parse(localStorage.getItem("pageTracking"))?.page;
    }
    else{
      let pageNo = null;
      let pgDetails = JSON.parse(localStorage.getItem("pageTracking"));
      if (pgDetails) {
        // let pageDetails = JSON.parse(localStorage.getItem("pageTracking"));
        if(val)
          pageNo=1;
        else
          pageNo = pgDetails.page;
      } else {
        pageNo = 1;
      }
      return pageNo;
    }
  }
  componentDidMount() {
    if(localStorage.getItem("req")){
      let pgDetail = JSON.parse(localStorage.getItem("pageTracking"))
      this.setState({...this.state, totalRows: pgDetail?.totalRows})
    }
    localStorage.removeItem("req")

    if (!localStorage.getItem('access_token')) {
      this.props.history.push('./login')
    } else {
      USER.user = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")) : null;
      if(this.state.state){
        this.setState({
          requests : this.props.location.state.requests,
          totalRows : this.props.location.state.totalRows,
          status: this.props.match.params.status,
          messageAPI: '',
          statusId: this.assignStatusId(this.props.match.params.status),
        },() => {
          this.setRowsOfTable(1)
        })
      }else{
        this.assignStatusId()
        console.log("componentDidMount::" + this.state.status + "Call Appointment")
        let data = JSON.parse(localStorage.getItem("pageTracking"))
        this.callAppointmentDetails(null, this.state.pageNo, data&&data.startTime?data.startTime:this.state.startDate, data&&data.endTime?data.endTime:this.state.endDate, this.state.statusId, 
          (data && data.sla)? SLA_FILTERS[this.props.match.params.status==='confirmed'?'Confirmed Appointments':'New Appointments']:this.state.slaBreachType);
      }
    }
  }

  componentDidUpdate(prevProps) {
    
    
    if(prevProps.location.pathname !== this.props.location.pathname){
      this.setState({...this.state, pageNo:1, totalRows:null}, ()=>{
        let pgno = JSON.parse(localStorage.getItem("pageTracking"));
        if(pgno){
          pgno.page = 1;
          localStorage.setItem("pageTracking", JSON.stringify(pgno))
        }
          this.setRowsOfTable(1)})
    }
    if ((this.props.searchAPIValues !== prevProps.searchAPIValues)) {
      if(prevProps.searchAPIValues!==null && this.props.searchAPIValues ==null){
        this.callAppointmentDetails(null, 1, this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType, true)
        return
      }
      console.log("nextProps.searchAPIValues !== this.state.searchAPIValues",this.props.searchAPIValues )
      this.setState({
        ...this.state,
        requests : this.props.searchAPIValues.requests,
        messageAPI : '',
        totalRows : this.props.searchAPIValues.totalRows,
        status: this.props.match.params.status,
        slaBreachType : null,
        statusId: this.assignStatusId(this.props.match.params.status),
        searchAppointment:this.props.searchAppointment,
      },() => {
        this.setRowsOfTable(1)
      });
    }

    if (this.props.match.params.status !== this.state.status && this.props.location.state === undefined) {
      let obj = JSON.parse(localStorage.getItem("pageTracking"))

      this.setState({
        ...this.state, 
        startDate: (obj && obj.startTime)? obj.startTime:"",
        endDate: (obj && obj.endTime)? obj.endTime:"",
        status: this.props.match.params.status,
        slaBreachType : (obj && obj.sla)? SLA_FILTERS[this.props.match.params.status==='confirmed'?'Confirmed Appointments':'New Appointments']: null,
        statusId: this.assignStatusId(this.props.match.params.status),
        searchAppointment:null,
      }, () => {
        this.callAppointmentDetails(null, this.getPageNo(this.props.match.params.status), this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType)
      });
    }

    if(this.props.match.params.status !== this.state.status && this.props.location.state && this.props.location.state !== this.state.state){
      this.setState({
        ...this.state,
        requests : this.props.location.state.requests,
        messageAPI : '',
        totalRows : this.props.location.state.totalRows,
        status: this.props.match.params.status,
        slaBreachType : null,
        statusId: this.assignStatusId(this.props.match.params.status),
        searchAppointment: null,
      },() => {
        this.setRowsOfTable(1)
      })
    }

    if( this.props.selectedProviders.length !== prevProps.selectedProviders.length ){
      this.callAppointmentDetails(null, 1, this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType, true)
    }
  }

  assignStatusId(status) {
    switch (status) {
      case 'confirmed': return STATUS_CODE_MAP["Confirmed by Medical Center"];
      case 'notAttended': return STATUS_CODE_MAP["Not Attended"];
      default: return STATUS_CODE_MAP["New Appointment Request"]; 
    }
  }

  assignPageToDashboard(status, value) {
    switch (status) {
      case 'confirmed': this.setPageTrack(2, value); break;
      case 'notAttended': this.setPageTrack(8, value); break;
      default: this.setPageTrack(1, value); break;
    }
  }

  createData(requestid, employeeId, employeeMailID, contactNo, customername, corporatename, appointmentdetails, packagedetails, appointmentdate, appointmentdatetime, additionals, visitType, dateTime, rowData, isHNI, currentProvider) {
    let breachTime=null;
    switch (this.state.status) {
      case "confirmed":
        breachTime = checkSlaTime(rowData.formattedfulfillmentDate,4)
        break;
      case "notAttended":
        // breachTime = checkSlaTime(rowData.formattedfulfillmentDate,4)
        break;
    
      default:
        breachTime = checkSlaTime(rowData.createdOn,12)
        break;
    }
    return {
      requestid,
      employeeId,
      employeeMailID,
      contactNo,
      customername,
      corporatename,
      appointmentdetails,
      packagedetails,
      appointmentdate,
      appointmentdatetime,
      additionals,
      visitType,
      dateTime,
      rowData,
      isHNI,
      breachTime:breachTime,
      currentProvider
    };
  }

  getHNI(additionalInformation) {
    return additionalInformation.priorityForRequest && additionalInformation.priorityForRequest.priorityName && additionalInformation.priorityForRequest.priorityName.toUpperCase().indexOf("HNI") > -1 ? true : false;
  }

  setRowsOfTable = () => {
    let rows = [];
    if (this.state.requests && this.state.requests !== '' && this.state.requests.length > 0) {
      let tuples = this.state.requests;
      if (tuples) {
        tuples.map((elem) => {
          if (elem !== undefined) {
            rows.push(this.createData(elem.requestId,
              elem.additionalInformation.employeeID,
              MaskElement(elem.additionalInformation.employeeMailID, elem.additionalInformation.additionals),
              elem.additionalInformation.visitType==="Home_Visit"?elem.additionalInformation.contactNo:
              MaskElement(elem.additionalInformation.contactNo, elem.additionalInformation.additionals),
              elem.additionalInformation.patientName,
              elem.additionalInformation.primaryEntityName ? elem.additionalInformation.primaryEntityName : elem.additionalInformation.providerName,
              elem.currentStatus, elem.additionalInformation.productName,
              getAppointmentDate(elem.formattedfulfillmentDate),
              getAppointmentTime(elem.formattedfulfillmentDate),
              elem.additionalInformation.additionals,
              elem.additionalInformation.visitType,
              getCorrectDateFormat(elem.formattedfulfillmentDate),
              elem,
              this.getHNI(elem.additionalInformation),
              elem.currentProvider))
          }
          return true;
        })
      }
      else {
        return false;
      }

    }
    this.setState({
      ...this.state,
      rows: rows,
      pageNo: this.getPageNo(this.state.status)
    })
  }

  onChangeStartDate = (value) => {
    this.setState({
      ...this.state,
      startDate: value
    })
    console.log("start date ::", value)
  }
  onChangeEndDate = (value) => {
    this.setState({
      endDate: value
    })
    console.log("end date :: ", value)
  }

  setPageTrack(id, value) {
    if (localStorage.getItem("pageTracking")) {
      let dashboards = JSON.parse(localStorage.getItem("pageTracking"));
        if (dashboards.id === id) {
          dashboards.page = value;
        }
      localStorage.setItem('pageTracking', JSON.stringify(dashboards));
    }
  }

  onChangeSLAFilters(value){
    this.setState({
      ...this.state,
      slaBreachType: value,
      pageNo:1,
      totalRows:0
    },() => {
      let pgDetails = JSON.parse(localStorage.getItem("pageTracking"))
      pgDetails.page = 1;
      localStorage.setItem("pageTracking", JSON.stringify(pgDetails));
      this.callAppointmentDetails(null, this.state.pageNo, pgDetails.startTime ? pgDetails?.startTime : this.state.startDate, pgDetails.endTime ? pgDetails?.endTime : this.state.endDate, this.state.statusId, this.state.slaBreachType)
    })
  }

  onDateSearch = (value) => {
    if (value) {
      this.assignPageToDashboard(this.state.status, 1)
      console.log("this.getPageNo(this.state.status) ", this.getPageNo(this.state.status))
      this.setState({
        ...this.state,
        pageNo: this.getPageNo(this.state.status),
        totalRows:0
      }, () => {
        let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
        pgTrack.totalRows = 0;
        localStorage.setItem("pageTracking",JSON.stringify(pgTrack))
        this.callAppointmentDetails(null, this.state.pageNo, pgTrack&&pgTrack.startTime?pgTrack.startTime:this.state.startDate, pgTrack&&pgTrack.endTime?pgTrack.endTime:this.state.endDate, this.state.statusId, this.state.slaBreachType)
      })
    }
  }

  onChangePageAppointment = (value) => {
    if (value != null) {
      console.log("value", value);
      if (value) {
        this.assignPageToDashboard(this.state.status, value)
        this.setState({
          ...this.state,
          rows: [],
          pageNo: this.getPageNo(this.state.status),
        }, () => {
          let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
          this.callAppointmentDetails(null, this.state.pageNo, pgTrack&&pgTrack.startTime?pgTrack.startTime:this.state.startDate, pgTrack&&pgTrack.endTime?pgTrack.endTime:this.state.endDate, this.state.statusId,  (pgTrack && pgTrack.sla)? SLA_FILTERS[this.props.match.params.status==='confirmed'?'Confirmed Appointments':'New Appointments']:this.state.slaBreachType)
        })
      }
    }
  }


  showErrorMessage() {
    return (this.state.messageAPI !== '' ? <Alert severity="error">
      <AlertTitle className="uppercase">{this.state.messageAPI}</AlertTitle>
      <strong>Please Logout and try again !</strong>
    </Alert> : '')
  }

  callAppointmentDetails (searchAppointment, pageNo, firstDate, endDate, statusId, slaBreachType, isCountRequired = true) {
    const that = this;
    console.log(this.state)
    let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
    searchAppointment = this.props.searchAPIValues;
    AppointmentDetails(searchAppointment, pageNo - 1, firstDate, endDate, statusId, slaBreachType, isCountRequired? isCountRequired: pgDetail && pgDetail?.totalRows ? false: this.state.totalRows?false:true).then(data => {
      if (data && data.errorStatus && data.errorStatus !== 200 && data.errorResponse && data.errorResponse !== undefined) {
        this.setState({
          ...this.state,
          messageAPI: data.errorResponse ? data.errorResponse.data.responseStatus.message : ''
        })
        toast.error(`Unable to fetch appointments ${data?.errorResponse?.data?.responseStatus?.message ?? ""}`)
      }
      else {
        this.setState((state)=>({
            requests: data?.requests ? data.requests : [],
            messageAPI: '',
            totalRows: isCountRequired ? data?.totalRows : state?.totalRows ? state?.totalRows : data?.totalRows,
          }), () => {
            let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
            // pgDetail.totalRows = this.state && this.state.totalRows? this.state.totalRows:data.totalRows;
            if(pgDetail) {
              pgDetail["totalRows"] = that?.state && that?.state?.totalRows? that?.state?.totalRows : data?.totalRows;
            }
            localStorage.setItem("pageTracking",JSON.stringify(pgDetail));
            this.setRowsOfTable(pageNo)
          });
        }
    })
  }

  render() {
    return (
      <Container maxWidth="xlg" className={this.state.isMobileView ? "pt-3 appointment-container-xs pd-xs-0" : "pt-3"}>
        {this.showErrorMessage()}
        <AppointmentConfirmedTable
          status={this.state.status} 
          pageNo={this.state.pageNo} 
          totalRows={this.state.totalRows || 0} 
          rows={this.state.rows || []} refreshData={() => this.callAppointmentDetails(null, this.state.pageNo, this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType)}
          onChangePage={(event) => this.onChangePageAppointment(event)} onChangeStartDate={(event) => this.onChangeStartDate(event)} 
          onChangeEndDate={(event) => this.onChangeEndDate(event)}
          action={this.state.action}
          onDateSearch={(event) => this.onDateSearch(event)}
          loadCasesOnFilters={(event) => this.onChangeSLAFilters(event)}
          slaBreachType={this.state.slaBreachType}
          resetFilter = {this.props.resetFilter}
          searchAppointment = {this.state.searchAppointment}
          setIsMobileView = {this.setIsMobileView}
          isMobileView={this.state.isMobileView}
          >
        </AppointmentConfirmedTable>
      </Container >
    )
  }
}

export default AppointmentConfirmedProvider;